/**
 * Load a script asynchronously.
 *
 * Based on {@link https://attacomsian.com/blog/javascript-load-script-async snippet by Atta}.
 */

/**
 * @typedef {Object} ScriptState
 *
 * @property {boolean}         loaded  - Returns `true` if the resource has successfully loaded,
 *     otherwise `false` if it failed to load or can't be used.
 * @property {?(Error|string)} reason  - The reason why the operation was aborted,
 *     which can be any JavaScript value.
 */

/**
 * @param  {string|URL} src
 * @param  {Element}    [container]
 * @param  {string}     [type]
 * @param  {boolean}    [async]
 * @return {Promise}
 */
export function loadScript(src, type = 'text/javascript', async = true, container = null) {
    return new Promise((resolve, reject) => {
        try {
            const script = document.createElement('script');

            script.type  = type;
            script.async = async;
            script.src   = src;

            script.addEventListener('load', () => {
                resolve({
                    loaded: true,
                });
            });

            script.addEventListener('error', () => {
                reject({
                    loaded: false,
                    reason: `Failed to load script ${src}`,
                });
            });

            container ??= document.head ?? document.body;

            container.appendChild(script);
        } catch (err) {
            reject({
                loaded: false,
                reason: err,
            });
        }
    })
}
